<div class="icon-input-field">
  <ng-container *ngIf="!!model[key]">
    <ibex-icon (click)="openSelector()" *ngIf="type === 'new'" [name]="model[key]" [variant]="variant"></ibex-icon>
  </ng-container>
  <ibex-icon *ngIf="!model[key]" (click)="openSelector()" name="search-2" variant="blank"></ibex-icon>
  <mat-form-field>
    <input (change)="change($event)" [(ngModel)]="model[key]" matInput placeholder="Icon auswählen oder eingeben">
  </mat-form-field>
  <!--<mat-icon (click)="openSelector()">edit</mat-icon>-->
</div>
